const imageInput = document.getElementById("car-note-images-input");
const fileCounter = document.getElementById("car-note-images-counter");

if (imageInput && fileCounter) {
  imageInput.addEventListener("change", () => {
    fileCounter.innerText = `(${imageInput.files.length} files selected)`;
  });
}
